'use client';

import React from 'react';

import { Button, Card, Chip, Heading } from '@ui';
import { Container, Section } from '@layout';
import { withOptionalId } from '@lib/withOptionalId';
import MarkupSnippet, { markupCopyLabels } from '../markup-snippet/MarkupSnippet';

interface DataDashboardCompositionProps {
  sectionID?: string;
  classes?: string;
  cardClassName?: string;
  isSpanish?: boolean;
}

const DataDashboardComposition: React.FC<DataDashboardCompositionProps> = ({
  isSpanish = false,
  sectionID = 'data-dashboard-pattern',
  classes = '',
  cardClassName,
}) => {
  const t = (en: string, es: string) => (isSpanish ? es : en);

  return (
    <Section {...withOptionalId(sectionID)} className={classes}>
      <Container>
        <Heading
          as='h3'
          title={t('Pattern: data dashboard slice', 'Patron: panel de datos')}
          description={t(
            'Filters, density, and tabular data are composed below—this block previews how those pieces align in one toolbar.',
            'Filtros, densidad y datos tabulares se componen mas abajo—este bloque anticipa como encajan en una barra de herramientas.'
          )}
        />
        <Card className={`${cardClassName}`}>
          <div
            className='pattern-composition__toolbar row gap'
            style={{ flexWrap: 'wrap', alignItems: 'center' }}
          >
            <Chip label={t('Status: Active', 'Estado: Activo')} />
            <Chip label={t('Region: All', 'Region: Todas')} />
            <div style={{ flex: 1, minWidth: '12rem' }} />
            <Button label={t('Export', 'Exportar')} className='btn-secondary' type='button' />
            <Button label={t('Refresh', 'Actualizar')} className='btn-primary' type='button' />
          </div>
          <p className='small' style={{ color: 'var(--muted)', margin: '1.2rem 0 0' }}>
            {t(
              'See Data table and Filters for full implementations and accessibility behavior.',
              'Ver Tabla de datos y Filtros para implementaciones completas y accesibilidad.'
            )}
          </p>
        </Card>
      <MarkupSnippet
          {...markupCopyLabels(isSpanish)}
          code={`<article class="card metric">
  <span class="metric-title">Open items</span>
  <div class="metric-value">24</div>
</article>`}
        />
      </Container>
    </Section>
  );
};

export default DataDashboardComposition;
